import { ErrorBoundary } from '@sentry/react';
import Select from 'react-select';

import DateTimeSelector from 'components/TripScreen/TripSearchScreen/DateTimeSelector';
import ExitButton from 'components/ExitButton';
import Icon from 'components/Icon';
import LoadingAnimation from 'components/common/LoadingAnimation';
import LocationWaypoint from 'components/TripScreen/TripSearchScreen/LocationWaypoint';
import TripOptions from 'components/TripScreen/TripSearchScreen/TripOptions';
import LoadingSpinner from './LoadingSpinner';
import lokalise from 'utils/lokalise';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';

function TripSearchScreen({
    isPermanent,

    getTripPlan,

    startingLocation,
    endingLocation,
    setStartingLocation,
    setEndingLocation,
    startDate,
    startTime,
    setStartDate,
    setStartTime,
    searchingTrips,
    loading,
    setLoading,

    statusMessage,
    errorCount,

    searchAreaLocation,
    tripOptions,
    selectTripOption,

    toggleTripScreen,
    onClickStatusMessage,

    params
}) {

    const [makePlan, setMakePlan] = useState(false);
    const [leaveBy, setLeaveBy] = useState({
        label: 'Leaving at',
        value: 'leaveBy'
    });

    const [searchParams, setSearchParams] = useSearchParams();
    const leaveOptions = [{
        label: 'Leaving at',
        value: 'leaveBy'
    }, {
        label: 'Arriving at',
        value: 'arriveBy'
    }]


    function formatDateAndTime() {
        const offset = new Date().getTimezoneOffset() * 60000;
        const today = new Date(Date.now() - offset);
        const date = today.toISOString().substring(0, 10);
        const time = today.toISOString().substring(11, 16);
        return [date, time]
    }

    function submitTripPlan() {
        const defaultDateTime = formatDateAndTime();
        let submittedDate = startDate ? startDate : defaultDateTime[0];
        let submittedTime = startTime ? startTime : defaultDateTime[1];

        if (submittedDate) {
            submittedDate = submittedDate.replaceAll("-", "");
        }

        // console.log(submittedDate, submittedTime);
        getTripPlan(submittedDate, submittedTime);
    }

    function onTripSearch() {
        if (startingLocation && endingLocation) {
            setLoading(true);
            submitTripPlan();
        }
    }

    return (
        <div className="TripSearchScreen">

            <div className="search-area">
                <header className="header">
                    {!isPermanent && <ExitButton showButton={true} tapEvent={() => toggleTripScreen(false)} />}
                    <LoadingSpinner loading={loading} />
                    <h1>{loading ? lokalise.getKey('ts13p') : lokalise.getKey('ts13n')}</h1>
                </header>
                {
                    loading
                    ? <></>
                    : <>
                        <div className="planner-options">
                            <div className="plan-option" onClick={() => {setMakePlan(false)}}>
                                <Icon category="ui" name="mapLocation" color={`${makePlan ? '#eee' : '#2386EE'}`} />
                                <p style={{color: makePlan ? '#fff' : '#2386EE'}}>Leave now</p>
                            </div>
                            <div className="plan-option" onClick={() => {setMakePlan(true)}}>
                                <Icon category="ui" name="calendar" fillColor={`${makePlan ? '#2386EE' : '#eee'}`} /> 
                                <p style={{color: makePlan ? '#2386EE' : '#fff'}}>Make a plan</p>
                            </div>
                        </div>
                        <div className="locations">
                            <div className="waypoints">
                                <ErrorBoundary fallback={<>{lokalise.getKey("ts12d")}</>}>
                                    <h3>From:</h3>
                                    <LocationWaypoint locked={searchParams.get('tpFrom') === 'locked'} label={lokalise.getKey('ts13j')} placeholder={lokalise.getKey('ts10f')} location={startingLocation} searchAreaLocation={searchAreaLocation} updateLocation={setStartingLocation} />
                                    <h3>To:</h3>
                                    <LocationWaypoint locked={searchParams.get('tpTo') === 'locked'} label={lokalise.getKey('ts13k')} placeholder={lokalise.getKey('ts10g')} location={endingLocation} searchAreaLocation={searchAreaLocation} updateLocation={setEndingLocation} />
                                </ErrorBoundary>
                            </div>
                        </div>
                        <div className="advanced" style={{ display: makePlan ? '' : 'none' }}>
                            <DateTimeSelector locked={searchParams.get('tpDate') === 'locked'} type='date' startDate={startDate} setStartDate={setStartDate} startTime={startTime} setStartTime={setStartTime} />
                            <div className="datetime-container">
                                <Select className="dropdown" options={leaveOptions} value={leaveBy} onChange={(e) => setLeaveBy({value: e.value, label: e.label})} />
                                <DateTimeSelector locked={searchParams.get('tpTime') === 'locked'} type='time' startDate={startDate} setStartDate={setStartDate} startTime={startTime} setStartTime={setStartTime} />
                            </div>
                        </div>
                        <button className="search-button" onClick={() => onTripSearch()}>{lokalise.getKey('ts13o')}</button>
                    </>
                }
            </div>

            <StatusMessage statusMessage={statusMessage} errorCount={errorCount} onClickStatusMessage={onClickStatusMessage} params={params} />

            {/* !tripOptions && <MobilityScoreBadge startLocation={startingLocation} /> */}

            <TripOptions tripOptions={tripOptions} selectTripOption={selectTripOption} searchingTrips={searchingTrips} />

            {/* <PoweredByAF /> */}
        </div>
    )
}

function StatusMessage({ statusMessage, errorCount, onClickStatusMessage, params }) {
    return (
        <div className={`status-message ${statusMessage ? 'visible' : ''}`} onClick={onClickStatusMessage}>
            <div className="text">{statusMessage}</div>
        </div>
    )
}

export default TripSearchScreen;
